import { connect } from 'react-redux';
import Table from './ApplicationTable';
import React, { createContext, useContext, useState, useEffect, useCallback } from "react"
// import { CSVLink, CSVDownload } from "react-csv";
import Button from '@mui/material/Button';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import LocalizationProvider from '@mui/lab/LocalizationProvider';
import Grid from '@mui/material/Grid';
import moment from 'moment';
// import DateFnsUtils from '@date-io/date-fns';
import DateFnsUtils from '@mui/lab/AdapterDateFns';
import ja from "date-fns/locale/ja";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import PropTypes from 'prop-types';
import { Authentication } from '../../App'
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { purple, red, grey } from '@mui/material/colors';
import {
    useParams,
  } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import { NumericFormat } from 'react-number-format';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import FormLabel from '@mui/material/FormLabel';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';



function MinusNumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    const [valueset, setValueset] = useState(0);
    console.log(props)
    return (
      <NumericFormat
        {...other}
        ref={inputRef}
        style={{ textAlign: 'right' }}
  
        onValueChange={values => {
  
          // console.log(values.value ? String(parseInt(values.value) * -1) : 0)
          setValueset(values.value)
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
  
        thousandSeparator={true}
        // prefix={valueset > 0 ? '-' : ''}
      />
    );
  }

function NewApplicationIndex(props) {

    const { id } = useParams();
    /////////////////////////////////////
    const [completed, setCompleted] = useState(false);
    const [year_list, setYearList] = useState([""]);
    const [application_form_id, setApplicationFormId] = useState(0);
    const [application_id, setApplicationId] = useState(0);
    
    const [form_title, setFormTitle] = useState([]);// 申請タイトル
    const [form_remarks, setFormRemarks] = useState([]);// 再申請理由
    const [form_detail, setFormDetail] = useState([]);// 入力フォーム
    const [form_authorizer, setFormAuthorizer] = useState([]);
    const [detail, setDetail] = useState([]);
    const [userlist, setUserList] = useState([]);//ユーザーリスト
    const [training_event_list, setTrainingEventList] = useState([]);//研修リスト
    const [tatemono_list, setTatemonoList] = useState([]);//建物リスト
    const [room_list, setRoomList] = useState([]);//部屋リスト
    const [error, setError] = useState("");//エラーリスト

    const [application_detail, setApplicationDetail] = useState([]); //申請済みのデータ
    const [form_id, setFormId] = useState([]);

    // const token = authentication.getAccessToken();
    const authentication = useContext(Authentication)

    const getApplicationDetail = async (application_id) => {
        // alert(application_id)
        // 申請内容
        var f = await fetch(`http://localhost:5000/v1/flw/applications/detail/` + application_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        var d = await f.json()
        setApplicationDetail(d)

        setFormId(d[0].form_id)//フォームID
        setApplicationFormId(d[0].form_id)//form_idセット
        getFormDetail(d[0].form_id)//入力フォームリスト取得
        setFormTitle(d[0].title)

        // 申請データをセット
        let new_data = []
        let new_data_tatemono = []
        let new_data_room = []
        for (let i = 0; i < d.length; i++) {
            new_data.push(d[i].form_value)
            if(d[i].formitem_id == 11){
                new_data_tatemono.push([{tatemono_id: d[i].tatemono_id, tatemono_name:d[i].tatemono_name}])
                new_data_room.push([{room_id: d[i].room_id, room_name:d[i].room_name}])
            } else if(d[i].formitem_id == 14){
                new_data_tatemono.push([{tatemono_id: d[i].tatemono_id, tatemono_name:d[i].tatemono_name}])
                new_data_room.push("")
            }else{
                new_data_tatemono.push("")
                new_data_room.push("")
            }
        }
        setDetail(detail.concat(new_data))
        setTatemonoList(tatemono_list.concat(new_data_tatemono))
        setRoomList(room_list.concat(new_data_room))
        

        if(d[0].form_id == 42){// 研修
            getTrainingEventListData()
        }

    }


    // 項目は何があるか取得
    const getFormDetail = async (application_form_id) => {
// alert(application_form_id)
        const f = await fetch(`http://localhost:5000/v1/flw/form/adds/list/` + application_form_id, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setFormDetail(d.flw_form_adds.filter(a=>a.del_flg == 0))
        // setApplicationDetail(d.flw_forms)
        // setFormTitle(d.flw_forms.form_name)
        // alert(d.length)
        // await getDefault(d.flw_form_adds.filter(a=>a.del_flg == 0))

    }

    // 再申請
    const updateApplication = async () => {
        let data = {
            form_id: application_form_id,
            application_id: application_id,
        }
        data["form_detail"] = form_detail
        data["title"] = form_title
        data["remarks"] = form_remarks
        data["detail"] = detail
        const f = await fetch(`http://localhost:5000/v1/flw/applications/re`, { method: 'put', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        // setApplicationId(d)
    }

    const getTatemonoList = async (key, kbn, name) => {
        // alert(application_form_id)
        let data = {
            name: name,
        }
        let url = ""
        if(kbn == 1){// 建物
            url = "http://localhost:5000/v1/tm/tatemono/searchname"
        }else{// P
            url = "http://localhost:5000/v1/tm/parking/searchname"
        }
        
        const f = await fetch(url, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        // console.log("tatemonolist", d)
        // setTatemonoList(d)
        setTatemonoList((prevDetail) => prevDetail.map((value, index) => (index === key ? d : value)));

    }

    const getRoomList = async (key, kbn, tatemono_id) => {
        // alert(application_form_id)
        let url = ""
        if(kbn == 1){// 建物
            url = "http://localhost:5000/v1/tm/room/list"
        }else{// P
            url = "http://localhost:5000/v1/tm/parkingarea/list"
        }

        let data = {
            tatemono_id: tatemono_id,
        }
        const f = await fetch(url, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        console.log("toomlist", d)
        // setRoomList(d)
        setRoomList((prevDetail) => prevDetail.map((value, index) => (index === key ? d : value)));
    }

    const getTatemonoTantou = async (key, kbn, tatemono_id) => {
        // alert(application_form_id)
        let url = ""
        if(kbn == 1){// 建物
            url = "http://localhost:5000/v1/search/rooms/roomlist"
        }else{// P
            return
        }

        let data = {
            tatemono_id: tatemono_id,
        }
        const f = await fetch(url, { method: 'post', body: JSON.stringify(data), headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        console.log("roomslist", d)
        // setRoomList(d)
        if(d.length > 0){
            setDetail((prevDetail) =>
                prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 2 ? d[0].Owner_Tantou_No : value2)).join(',') : value))
            );
        }
    }

    
    const getYearList = async () => {
        
        for (let i = 1900; i <= parseInt(moment().add(5, 'years').format("YYYY")); i++) {
            setYearList((oldValue => [...oldValue, i]))   // ←変更
            // setYearList([...year_list, i]);
        }
    }
    
    const getUsersListData = async () => {
        const f = await fetch(`http://localhost:5000/v1/users/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setUserList(d)
    }

    const getTrainingEventListData = async () => {
        const f = await fetch(`http://localhost:5000/v1/training/events/list`, { method: 'get', headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } })
        const d = await f.json()
        setTrainingEventList(d)
    }

    useEffect(() => {

        if(id > 0){
            // alert(id)
            setApplicationId(id) //アプリケーションIDをセット
            getApplicationDetail(id) //詳細を取得

        }

        getYearList()
        getUsersListData()

    }, [props])

    // 通常
    const onChangeDetail = (e, key) => {
        if(id == 42 && key == 0){
            setDetail((prevDetail) => prevDetail.map((value, index) => (index === key ? e : value)));
            setDetail((prevDetail) => prevDetail.map((value, index) => (index === key + 1 ? "" : value)));
        }else{
            setDetail((prevDetail) => prevDetail.map((value, index) => (index === key ? e : value)));
        }
        
    }
    // 日付
    const onChangeDetailDate = (e, key) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? moment(e).format("YYYY/MM/DD") : value))
        );
    }
    // 担当
    const onChangeDetailUser = (e, id, key) => {

        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? String(id) : value))
        );
    }
    
    // チェックボックス
    const onChangeDetailCheckbox = (e, key, choice_value, choice_key) => {
        if(e){
            setDetail((prevDetail) =>
                // prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === choice_key ? choice_value : value2)).join(',') : value))
                prevDetail.map((value, index) => (index === key ? value + (value ? "," : "") + choice_value : value))
            );
        } else {
            setDetail((prevDetail) =>
                // prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === choice_key ? "" : value2)).join(',') : value))
                prevDetail.map((value, index) => (index === key ? value.split(",").filter(value2 => value2 != choice_value).join(',') : value))
            );
        }
    }

    // 年月の年の部分
    const onChangeDetailNen = (e, key) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 0 ? e : value2)).join(',') : value))
        );
    }
    // 年月の月の部分
    const onChangeDetailMonth = (e, key) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 1 ? e : value2)).join(',') : value))
        );
    }

    // 建物の区分（建物orP）の部分
    const onChangeTatemonoKbn = (e, key, idx) => {
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === idx ? e : value2)).join(',') : value))
        );
        //未選択に
        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 1 || index2 === 2 ? "" : value2)).join(',') : value))
        );
        // リストを初期化
        setTatemonoList((prevDetail) => prevDetail.map((value, index) => (index === key ? [] : value)));
        setRoomList((prevDetail) => prevDetail.map((value, index) => (index === key ? [] : value)));
    }
    const onChangeTatemono = (e, id, key, idx, item_id) => {

        setDetail((prevDetail) =>
            prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === idx ? id : value2)).join(',') : value))
        );

        if(idx == 1){// 建物変更時
            setDetail((prevDetail) =>
                prevDetail.map((value, index) => (index === key ? value.split(",").map((value2, index2) => (index2 === 2 ? "" : value2)).join(',') : value))
            );
            if(id > 0){ // 建物IDがあったら部屋リスト取得
                //部屋リスト取得
                getRoomList(key, detail[key].split(',')[0], id)

                if(item_id == 14){
                    //物件担当を取得
                    getTatemonoTantou(key, detail[key].split(',')[0], id)
                }
                
            }
        }
    }

    let timer
    const onChangeTatemonoList = (e, key) => {
        if (e.target.value) {
            let name = e.target.value
            let kbn = detail[key].split(',')[0]
            clearTimeout(timer);
            timer = setTimeout(() => {
                getTatemonoList(key, kbn, name)
            }, 400);
        }
    }

    const onClickApplication = () => {
        // alert("更新")
        // 

        let str = []
        if(application_form_id != 11 && application_form_id != 33 && form_title == ""){
            str.push("タイトルが入力されていません。")
        }
        
        for(let i=0; i<form_detail.length; i++){
            if(form_detail[i].required){
                if(form_detail[i].formitem_id === 11 || detail[i].formitem_id === 14 || detail[i].formitem_id === 9){//物件//担当//年月
                    if(detail[i].split(',')[0] == "" || detail[i].split(',')[1] == "" || detail[i].split(',')[2] == ""){
                        str.push(form_detail[i].formitem_name +"が入力されていません。")
                    }
                }else{
                    if(detail[i] == ""){
                        str.push(form_detail[i].formitem_name +"が入力されていません。")
                    }
                }
            }
        } 

        if(form_remarks == ""){
            str.push("再申請理由が入力されていません。")
        }

        setError(str)

        if(str == ""){
            setCompleted(true)
            updateApplication()//申請
        }else{
            // alert(str)
        }

    }

    return (
        
        <div style={{paddingTop:'54px', paddingLeft:64}}>
            {JSON.stringify(detail)}
            {application_id}
            {/* {JSON.stringify(tatemono_list)} */}
            {completed ? 
            <div style={{padding: 20, height: 300, width: "100%", position: "relative"}}>
                <span style={{backgroundColor: "white", border:"1px solid #c4c4c4", position: "absolute", top: "50%", left: "50%", transform: "translateY(-50%) translateX(-50%)", padding: "50px 100px"}}>申請しました</span>
            </div> : 
            <>
            <Card style={{margin:10, padding:10}}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
                <table className='flw_new_table'>
                    <tr>
                        {/* <th>
                            申請タイトル
                            {application_form_id != 11 && application_form_id != 33 ? <span className='required'>必須</span> : ""}
                        </th> */}
                        <td style={{padding:10}}>
                            <TextField 
                                label={"申請タイトル"}
                                style={{width:500}} 
                                value={form_title} 
                                size="small" 
                                // placeholder={value.remarks}
                                error={application_form_id != 11 && application_form_id != 33 && form_title == ""}
                                required={application_form_id != 11 && application_form_id != 33}
                                onChange={(e)=> {setFormTitle(e.target.value)}}
                                />
                        </td>
                    </tr>
                    {
                    form_detail.map(function (value, key) {
                        return <tr>
                            {/* <th>
                                {value.formitem_name}
                                {value.required ? <span className='required'>必須</span> : ""}
                            </th> */}
                            <td style={{padding:10}}>
                                {(() => {
                                    if (value.formitem_id === 1) {// テキスト
                                        return <TextField 
                                            label={value.formitem_name}
                                            style={{width:value.form_size ? value.form_size : 300}} 
                                            value={detail[key]} 
                                            size="small" 
                                            placeholder={value.remarks}
                                            required={value.required ? true : false}
                                            error={value.required && detail[key]==""}
                                            onChange={(e) => onChangeDetail(e.target.value, key)} />
                                    } else if (value.formitem_id === 2) {// 複数行
                                        return <TextField 
                                            label={value.formitem_name}
                                            style={{width:value.form_size ? value.form_size*10 : 300}} 
                                            multiline 
                                            maxRows={4} 
                                            value={detail[key]} 
                                            placeholder={value.remarks}
                                            required={value.required ? true : false}
                                            error={value.required && detail[key]==""}
                                            onChange={(e) => onChangeDetail(e.target.value, key)} 
                                            />
                                    } else if (value.formitem_id === 3) {// 数字
                                        return <TextField
                                            label={value.formitem_name}
                                            style={{width:value.form_size ? value.form_size : 300}} 
                                            placeholder={value.remarks}
                                            value={detail[key]}
                                            InputProps={{
                                                inputComponent: MinusNumberFormatCustom,
                                                endAdornment: <InputAdornment position="end">{value.remarks2}</InputAdornment>,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            required={value.required ? true : false}
                                            error={value.required && detail[key]==""}
                                            onChange={(e) => onChangeDetail(e.target.value, key)}
                                            size="small"
                                        />
                                    } else if (value.formitem_id === 4) {// 日付
                                        return <DatePicker
                                                // label="最終承認日　開始"
                                                label={value.formitem_name}
                                                name="approval_start_date"
                                                value={detail[key] != "" ? detail[key] : null}
                                                onChange={(e) => onChangeDetailDate(e, key)}
                                                renderInput={(params) => <TextField size="small"
                                                required={value.required ? true : false}
                                                error={value.required && (detail[key]=='' || detail[key]==null)}
                                                {...params} sx={{ mr: 1 }} />}
                                            />
                                    } else if (value.formitem_id === 5) {// 月選択
                                        return <FormControl size='small'>
                                                <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                                <Select
                                                    label={value.formitem_name}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key]}
                                                    onChange={(e) => onChangeDetail(e.target.value, key)}
                                                    style={{width:200}}
                                                    error={value.required && (detail[key]=='' || detail[key]==null)}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value}>{choice_value + "月"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                    } else if (value.formitem_id === 6) {// ラジオボタン
                                        return <>
                                        <FormLabel component="legend" style={{ marginBottom: 0, fontSize: 14 }} required={value.required ? true : false}>{value.formitem_name}</FormLabel>
                                        <RadioGroup row aria-label="position" name="color" 
                                        onChange={(e) => onChangeDetail(e.target.value, key)}
                                        value={detail[key]}
                                        >
                                                {value.choice.split(',').map(function (choice_value, choice_key) {
                                                    return <FormControlLabel control={<Radio style={{backgroundColor: value.required && detail[key] == "" ? "#fdece9": "transparent"}} value={choice_value} />} label={choice_value} />
                                                })}
                                            </RadioGroup>
                                        </>
                                    } else if (value.formitem_id === 7) {// プルダウン
                                        if(id == 42 && value.formitem_name == "研修名選択"){
                                            return <FormControl size='small'>
                                                <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                                <Select
                                                    label={value.formitem_name}
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key]}
                                                    onChange={(e) => onChangeDetail(e.target.value, key)}
                                                    style={{width:value.form_size ? value.form_size* 4 : 300}} 
                                                    error={value.required && (detail[key]=='' || detail[key]==null)}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {training_event_list.filter(a=>a.training_division == (detail[0] == "社外研修" ? 2 : detail[0] == "通信講座" ? 3 : 0)).map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value.training_event_id}>{choice_value.title}{(detail[0] == "社外研修" ? 2 : detail[0] == "通信講座" ? "("+moment(choice_value.training_day).format("YYYY/MM/DD")+")" : 0)}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        }else{
                                            return <FormControl size='small'>
                                                <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key]}
                                                    onChange={(e) => onChangeDetail(e.target.value, key)}
                                                    style={{width:value.form_size ? value.form_size* 4 : 300}} 
                                                    error={value.required && (detail[key]=='' || detail[key]==null)}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {value.choice.split(',').map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value}>{choice_value}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                        }
                                        
                                    } else if (value.formitem_id === 8) {// チェックボックス
                                        return <>
                                            <FormLabel component="legend" style={{ marginBottom: 0, fontSize: 14 }} required={value.required ? true : false}>{value.formitem_name}</FormLabel>
                                            {value.choice.split(',').map(function (choice_value, choice_key) {
                                                return <FormControlLabel control={<Checkbox style={{backgroundColor: value.required && detail[key] == "" ? "#fdece9": "transparent"}} checked={detail[key].split(',').includes(choice_value)} onChange={(e) => onChangeDetailCheckbox(e.target.checked, key, choice_value, choice_key)} />} label={choice_value} />
                                            })}
                                      </>
                                    } else if (value.formitem_id === 9) {// 年月選択
                                        return <div style={{display: "flex"}}>
                                            <FormControl size='small' >
                                            <InputLabel id="demo-simple-select-label" required={value.required ? true : false}>{value.formitem_name}</InputLabel>
                                            
                                            <Select
                                                label={value.formitem_name}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                value={detail[key].split(",")[0]}
                                                onChange={(e) => onChangeDetailNen(e.target.value, key)}
                                                style={{width:200}}
                                                error={value.required && detail[key].split(",")[0]==''}
                                            >
                                                {year_list.map(function (choice_value, choice_key) {
                                                    return <MenuItem value={choice_value}>{choice_value}</MenuItem>
                                                })}
                                            </Select>
                                            </FormControl>年
                                            <FormControl size='small' >
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={detail[key].split(",")[1]}
                                                    onChange={(e) => onChangeDetailMonth(e.target.value, key)}
                                                    style={{width:100}}
                                                    error={value.required && detail[key].split(",")[1]==''}
                                                >
                                                    <MenuItem value={""}></MenuItem>
                                                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(function (choice_value, choice_key) {
                                                        return <MenuItem value={choice_value}>{choice_value + "月"}</MenuItem>
                                                    })}
                                                </Select>
                                                </FormControl>日
                                            </div>
                                    } else if (value.formitem_id === 10) {// 時刻
                                        return <span>未対応</span>
                                    } else if (value.formitem_id === 11) {// 物件
                                        return <>
                                            <FormLabel required={value.required ? true : false} component="legend" style={{ marginBottom: 0, fontSize: 14 }}>{value.formitem_name}</FormLabel>
                                            
                                            <RadioGroup row aria-label="position" name="color" 
                                                onChange={(e) => onChangeTatemonoKbn(e.target.value, key, 0)}
                                                value={detail[key].split(',')[0]}
                                            >
                                                <FormControlLabel control={<Radio value={1} />} label={"物件"} />
                                                <FormControlLabel control={<Radio value={2} />} label={"駐車場"} />
                                            </RadioGroup>
                                            <div style={{display: "flex"}}>
                                            <Autocomplete
                                                id="tatemono_id"
                                                options={tatemono_list[key] == "" ? [] : tatemono_list[key]}
                                                getOptionLabel={(option) => option.tatemono_name ? option.tatemono_name : ''}
                                                style={{ width: 300 }}
                                                name="tatemono_id"
                                                value={detail[key].split(',')[1] == "" ? {tatemono_id:"", tatemono_name:""} : tatemono_list[key].length > 0 ? tatemono_list[key].filter(a => a.tatemono_id === detail[key].split(',')[1])[0]:{tatemono_id:detail[key].split(',')[1], tatemono_name:""}}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.tatemono_id ? newValue.tatemono_id : "", key, 1, value.formitem_id)}
                                                renderInput={(params) => <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                error={value.required && detail[key].split(",")[1]==''}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                    <React.Fragment>

                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                    ),
                                                }}
                                                onChange={(e)=>onChangeTatemonoList(e, key)}
                                                label={"物件名"} />}

                                            />
                                            <Autocomplete
                                                size="small"
                                                options={room_list[key] == "" ? [] : room_list[key]}
                                                getOptionLabel={(option) => option.room_name}
                                                value={detail[key].split(',')[2] == "" ? {room_id:"", room_name:""} : room_list[key].filter(a => a.room_id === detail[key].split(',')[2])[0]}
                                                style={{ width: 200 }}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.room_id ? newValue.room_id : "", key, 2, value.formitem_id)}
                                                renderInput={(params) => <TextField 
                                                    error={value.required && (detail[key].split(",")[2]=='')}
                                                    {...params} label={"部屋名"} />}

                                            />
                                            </div>
                                        </>

                                    } else if (value.formitem_id === 12) {// 添付ファイル 

                                        return <span>未対応</span>
                                    } else if (value.formitem_id === 13) {// エリア店長用
                                        return <><Autocomplete
                                            fullWidth
                                            size="small"
                                            options={userlist}
                                            getOptionLabel={(option) => option.user_name_all}
                                            value={detail[key] == "" ? {id:"",user_name_all:""} : userlist.filter(a => String(a.id) === String(detail[key]))[0]}
                                            style={{ width: 200 }}
                                            onChange={(e, newValue) => onChangeDetailUser(e, newValue && newValue.id ? newValue.id : "", key)}
                 
                                            renderInput={(params) => <TextField label={value.formitem_name} 
                                            required={value.required ? true : false}
                                            error={value.required && (detail[key]=='')}
                                                {...params} />}

                                        /></>
                                    } else if (value.formitem_id === 14) {// 物件部屋担当セットのやつ
                                        return <>
                                            <FormLabel component="legend" required={value.required ? true : false} style={{ marginBottom: 0, fontSize: 14 }}>{value.formitem_name}</FormLabel>
                                            <RadioGroup row aria-label="position" name="color" 
                                                onChange={(e) => onChangeTatemonoKbn(e.target.value, key, 0)}
                                                value={detail[key].split(',')[0]}
                                            >
                                                <FormControlLabel control={<Radio value={1} />} label={"物件"} />
                                                <FormControlLabel control={<Radio value={2} />} label={"駐車場"} />
                                            </RadioGroup>
                                            <div style={{display: "flex"}}>
                                            <Autocomplete
                                                id="tatemono_id"
                                                options={tatemono_list[key] == "" ? [] : tatemono_list[key]}
                                                getOptionLabel={(option) => option.tatemono_name ? option.tatemono_name : ''}
                                                style={{ width: 300 }}
                                                name="tatemono_id"
                                                value={detail[key].split(',')[1] == "" ? {tatemono_id:"", tatemono_name:""} : tatemono_list[key].length > 0 ? tatemono_list[key].filter(a => a.tatemono_id === detail[key].split(',')[1])[0]:{tatemono_id:"", tatemono_name:""}}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.tatemono_id ? newValue.tatemono_id : "", key, 1, value.formitem_id)}
                                                renderInput={(params) => <TextField
                                                {...params}
                                                variant="outlined"
                                                size="small"
                                                error={value.required && detail[key].split(",")[1]==''}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                    <React.Fragment>

                                                        {params.InputProps.endAdornment}
                                                    </React.Fragment>
                                                    ),
                                                }}
                                                onChange={(e)=>onChangeTatemonoList(e, key)}
                                                label={"物件名"} />}

                                            />
                                            
                                            <Autocomplete
                                                fullWidth
                                                size="small"
                                                options={userlist}
                                                getOptionLabel={(option) => option.user_name_all}
                                                value={detail[key].split(',')[2] != "" ? userlist.filter(a => String(a.id) == String(detail[key].split(',')[2]))[0] : null}
                                                style={{ width: 200 }}
                                                onChange={(e, newValue) => onChangeTatemono(e, newValue && newValue.id ? newValue.id : "", key, 2)}
                    
                                                renderInput={(params) => <TextField
                                                    error={value.required && detail[key].split(",")[2]==''}
                                                    {...params} label="担当" />}
                                            />
                                            </div>
                                        </>
                                    }
                                })()}
                                {/* {value.formitem_name} */}
                            </td>
                        </tr>
                    })
                    }
                    <tr>
                        <td style={{padding:10}}>
                            <TextField 
                                label={"再申請理由"}
                                required={true}
                                multiline
                                maxRows={4} 
                                style={{width:500}} 
                                value={form_remarks} 
                                size="small" 
                                // placeholder={value.remarks}
                                onChange={(e)=> {setFormRemarks(e.target.value)}}
                                error={form_remarks == ""}
                                />
                        </td>
                    </tr>
                </table>
                </LocalizationProvider>
            {/* </div> */}
            </Card>
            {error.length > 0?
                <Alert severity="error" style={{textAlign:"left"}}>
                {/* <AlertTitle>未入力の項目があります。</AlertTitle> */}
                {
                    error.map(function (value, key) {
                        return <div>{value}</div>
                    })
                }
              </Alert>
                :""
            }
            <Button style={{marginBottom:20}} size="large" variant="contained" color="success" onClick={()=>onClickApplication()}>再申請する</Button>
            </>}
        </div>
    );
}

export  default NewApplicationIndex;
